import { Fragment, useCallback, useMemo, useState } from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { Vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface Props {
  comment: string | null;
  color?: keyof Vars['color'];
}

export const Comment = ({ comment, color = 'textTertiary' }: Props) => {
  const [is_overflow, setIsOverflow] = useState(false);
  const [is_expanded, setIsExpanded] = useState(false);

  const comment_ref = useCallback((node: HTMLParagraphElement) => {
    if (node) {
      setIsOverflow(node.scrollHeight > node.offsetHeight);
    }
  }, []);

  const comments = useMemo(() => comment?.split('\n'), [comment]);

  const handleExpand = () => {
    if (is_overflow) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <CommentWrap is_expanded={is_expanded} onClick={handleExpand}>
      <Text ref={comment_ref} className='comment' as='p' variant='Body_13_Medium' color={color}>
        {comments?.map((text, index) => (
          <Fragment key={index}>{text}</Fragment>
        ))}
      </Text>
      {is_overflow && (
        <Text as='span' className='more-button' variant='Body_13_Medium' color={color}>
          {!is_expanded ? '더보기' : '접기'}
        </Text>
      )}
    </CommentWrap>
  );
};

const CommentWrap = styled.div<{ is_expanded: boolean }>`
  position: relative;
  display: inline-flex;
  width: 100%;
  padding: 16px 0 0;
  flex-direction: column;

  .comment {
    width: 100%;
    line-height: 18.2px;
    word-break: break-all;
    ${({ is_expanded }) =>
      is_expanded
        ? css`
            height: auto;
          `
        : css`
            height: auto;
            max-height: 36.4px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
          `};
    position: relative;
    background-color: white;
  }
  .more-button {
    outline: none;
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
  }
`;
